<div>
  <app-header
    [isLoggedIn]="isLoggedIn"
    [showAdminBoard]="showAdminBoard"
    [showManagerBoard]="showManagerBoard"
    [showUserBoard]="showUserBoard"
    [username]="username">
  </app-header>
</div>
<div class="container">
  <router-outlet></router-outlet>
</div>
